import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    // padding: theme.spacing(25, 27, 0),
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  textContainer: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(0, 10),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '64px',
    fontWeight: 800,
    lineHeight: '83px',
    textAlign: 'left',
    marginBottom: theme.spacing(7),
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
      lineHeight: '43px',
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',

      fontSize: '24px',
      lineHeight: '33px',
    },
  },
  secondaryHeading: {
    fontFamily: lato.style.fontFamily,
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '28px',
    textAlign: 'left',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      fontSize: '22px',
      lineHeight: '32px',
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',

      fontSize: '18px',
      lineHeight: '28px',
      marginBottom: theme.spacing(3),
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    textAlign: 'left',
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '21px',
      marginBottom: theme.spacing(8),
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: '14px',
      lineHeight: '17px',
      marginBottom: theme.spacing(8),
    },
  },
  btn: {
    border: 'none',
    background: 'black',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  wrapper: {
    width: 'fit-content',

    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(20),
      width: '100%',
    },
  },
  imgContainer: {
    marginLeft: 'auto',
    position: 'relative',
    width: '70%',
    height: '550px',
    maxWidth: '893.52px',
    [theme.breakpoints.down('md')]: {
      margin: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      height: '300px',
    },
  },
}))

export default useStyles
